export default "__VITE_ASSET__BZLCaGzI__"